import type { BrandContentFormat } from '../api/payment/brand-deal.api';

// Định dạng nội dung của chiến dịch (spec 2026-10-12 §3.2). Câu lỗi và thứ tự kiểm khớp BrandContentFormatRules phía payment.

export const CONTENT_FORMAT_OPTIONS: ReadonlyArray<{ value: BrandContentFormat; label: string }> = [
  { value: 'Video', label: 'Video' },
  { value: 'Image', label: 'Ảnh' },
  { value: 'Article', label: 'Bài viết' },
];

export const CONTENT_FORMAT_REQUIRED_MESSAGE = 'Hãy chọn định dạng nội dung.';

export const contentFormatLabel = (format?: string | null): string | null =>
  CONTENT_FORMAT_OPTIONS.find((o) => o.value === format)?.label ?? null;

export const contentFormatHint = (format?: string | null): string | null => {
  switch (format) {
    case 'Video':
      return 'Bài cần đúng 1 video, không kèm ảnh, phần chữ tối đa 2.000 ký tự.';
    case 'Image':
      return 'Bài cần từ 1 đến 10 ảnh, không kèm video, phần chữ tối đa 2.000 ký tự.';
    case 'Article':
      return 'Bài viết từ 100 đến 2.000 ký tự, có thể kèm tối đa 10 ảnh, không kèm video.';
    default:
      return null;
  }
};

export const validateContentFormat = (
  format: string | null | undefined,
  text: string,
  images: number,
  videos: number
): string | null => {
  if (!format) return null;
  const length = (text ?? '').trim().length;
  switch (format) {
    case 'Video':
      if (videos !== 1) return 'Chiến dịch này cần đúng 1 video.';
      if (images > 0) return 'Bài dạng video không kèm ảnh.';
      break;
    case 'Image':
      if (videos > 0) return 'Bài dạng ảnh không kèm video.';
      if (images < 1) return 'Chiến dịch này cần ít nhất 1 ảnh.';
      if (images > 10) return 'Tối đa 10 ảnh.';
      break;
    case 'Article':
      if (videos > 0) return 'Bài viết không kèm video.';
      if (length < 100) return 'Bài viết cần ít nhất 100 ký tự.';
      if (images > 10) return 'Tối đa 10 ảnh.';
      break;
    default:
      return 'Định dạng nội dung không hợp lệ.';
  }
  return length > 2000 ? 'Nội dung tối đa 2.000 ký tự.' : null;
};
